import { baseUrl } from "./type";
import http from "./http";

// GET all
export function getAllMemberTags(token) {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + `tags/allMemberTagsByBrandId`, {
            headers: {
                Authorization: "Bearer " + token,
            }
        })
            // .then((response) => resolve(response))
            .then((response) => {
                if (response.data.status === "success") {
                    resolve(response);
                } else {
                    console.log("[GET] All member tags Error:", response.data.message);
                    reject(new Error(response.data.message || "取得會員標籤失敗"));
                }
            })
            .catch((err) => {
                console.log("[GET] All member tags Failed:", err);
                if (err.response?.status === 401) {
                    reject(new Error("登入已過期，請重新登入"));
                } else if (err.response?.status === 404){
                    reject(new Error(err.response.data.message + " 找不到會員標籤"));
                } else if (err.response.data.status === 'failed'){
                    reject(new Error(err.response.data.message));
                } else if (err) {
                    reject(new Error(err));
                } else {
                    reject(new Error("發生未知錯誤，請稍後再試"));
                }
            });
    });
}

